import { IIconProps } from "../types"

export default function IconUR3(props: IIconProps) {
  const width = props.size || props.width || 66
  const height = props.size || props.height || 103
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 66 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.963 1.24126C26.793 0.811265 29.593 0.551265 31.843 0.941265C34.083 1.33126 35.783 2.38126 37.343 3.52126C38.903 4.65126 40.333 5.89126 43.003 10.3513C45.673 14.8113 49.583 22.4913 53.063 29.9813C56.543 37.4713 59.603 44.7613 61.523 50.4613C63.433 56.1513 64.193 60.2513 64.293 63.1513C64.383 66.0513 63.823 67.7413 62.953 69.9513C62.083 72.1713 60.913 74.9013 58.373 78.9113C55.833 82.9113 51.923 88.1813 48.633 92.1213C45.353 96.0613 42.683 98.6613 40.303 100.131C37.923 101.601 35.843 101.921 33.333 101.631C30.833 101.331 27.903 100.421 23.503 98.2113C19.113 96.0013 13.253 92.4813 9.57303 89.9113C5.89303 87.3413 4.40303 85.7113 3.26303 83.4613C2.12303 81.2213 1.34303 78.3513 0.983028 74.8013C0.623028 71.2613 0.683028 67.0213 1.14303 61.8213C1.60303 56.6113 2.44303 50.4213 4.13303 42.1913C5.83303 33.9513 8.37303 23.6613 10.383 16.7613C12.403 9.86126 13.903 6.35126 16.083 4.30126C18.263 2.25126 21.133 1.66126 23.963 1.24126Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
